import { type IAssuranceSummary } from '../model';

type ITotalProps = {
  count: number;
  caption: string;
};

const AssuranceTotal = ({ count, caption }: ITotalProps) => (
  <div role="group" aria-label={caption} className="space-y-2">
    <div className="flex items-baseline gap-1">
      <span className="text-3xl font-extrabold text-foreground">{count}</span>
      <span className="text-base font-bold text-muted-foreground">protections</span>
    </div>
    <p className="text-sm text-muted-foreground">{caption}</p>
  </div>
);

type Props = {
  summary: IAssuranceSummary;
};

const AssuranceTotals = ({ summary }: Props) => {
  const assuredCount = summary.certificationValidatedCount;

  return (
    <div className="grid grid-cols-2 divide-x divide-border">
      <AssuranceTotal count={assuredCount} caption="with assurance" />
      <div className="pl-6">
        <AssuranceTotal count={summary.totalProtectionsCount - assuredCount} caption="without assurance" />
      </div>
    </div>
  );
};

export default AssuranceTotals;
